module.exports = __webpack_public_path__ + "static/media/gallery5.2c7dc2b7.jpg";